import { useSSO } from '../../context/AuthContext';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import LoginIcon from '@mui/icons-material/Login';

import styles from "./Logout.module.css";

const theme = createTheme();

const LogoutPage = () => {
  const { login } = useSSO();

  return (
    <div className={`${styles.background} mainContainer`}>
      <ThemeProvider theme={theme}>
        <Container
          component="main"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
          }}
        >
          <CssBaseline />
          <Box
            sx={{
              position: 'relative',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: '#fcfafa',
              padding: '40px',
              borderRadius: '20px',
              width: '100%',
              maxWidth: 450,
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              textAlign: 'center',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '6px',
                background: 'linear-gradient(to right, #0088FF 0%, #1A4B99 50%, #1B2E4B 100%)',
              },
            }}
          >
            <img src="/logo192.png" className={styles.logo} alt='logo' />
            <Box
              sx={{
                mt: 1, display: 'flex',
                flexDirection: 'column',
                gap: 2,
              }}>
              <Typography
                sx={{
                  color: '#1e293b',
                  letterSpacing: '.3rem',
                  textDecoration: 'none',
                }}
              >
                <strong>PROPOSALGENERATOR</strong>
              </Typography>

              <Typography
                component='h6'
                variant='h5'
                sx={{
                  fontWeight: 500,
                  color: 'text.primary',
                  letterSpacing: '-0.025em'
                }}
              >
                You've been signed out
              </Typography>

              <Typography
                color='text.secondary'
              >
                Your session has ended. Sign back in via CPI's SSO to continue.
              </Typography>
              <Button
                fullWidth
                variant="contained"
                size='large'
                sx={{
                  mt: 1.5,
                  mb: 2,
                  borderRadius: 2.5,
                  textTransform: 'none'
                }}
                className={styles.btnStyle}
                startIcon={<LoginIcon />}
                onClick={login}
              >
                Sign back in with SSO
              </Button>

              <Typography
                color='text.secondary'
                sx={{
                  fontSize: '12px'
                }}
              >
                Access is managed by CPI's identity provider.
              </Typography>
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
    </div>
  );
};

export default LogoutPage;